import { render, staticRenderFns } from "./Question2.vue?vue&type=template&id=5dffd276&scoped=true&"
import script from "./Question2.vue?vue&type=script&lang=js&"
export * from "./Question2.vue?vue&type=script&lang=js&"
import style0 from "./Question2.vue?vue&type=style&index=0&id=5dffd276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffd276",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
